export default "__VITE_ASSET__0b6a5ebe__"